let activeRequests = 0;

export const startLoader = () => {
    activeRequests++;
    document.body.classList.add('loading'); // Or show a spinner in your app context
};

export const stopLoader = () => {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
        document.body.classList.remove('loading'); // Hide the loader
    }
};
